<template>
    <div class="ds-exchange-card">

        <div class="flex justify-between">
            <div class="ds-exchange-card-title mb-3">
                {{ position }}
            </div>
            <div class="flex ds-exchange-card-status">
                <VacancyStatus :status />
            </div>
        </div>

        <div class="ds-exchange-card-body">
        <div class="ds-exchange-card-date mb-2"><span class="pr-3">{{ date }}</span> {{ startTime }} - {{ endTime }}</div>
        
        <div class="ds-exchange-card-text ds-exchange-card-clamp mb-4">
            {{ department }}
        </div>

            <div v-if="salary" class="ds-exchange-card-muted ds-exchange-card-clamp mb-4">Ставка: {{ salary }} руб. в час</div>
            <Skills v-if="skills.length" :skills />
            <div v-if="comment" class="ds-exchange-card-muted ds-exchange-card-clamp mb-4">Комментарий: {{ comment }}
            </div>
        </div>

        <div class="ds-exchange-card-footer">
            <div v-if="assigned">
                <User :first-name="assigned.first_name" :last-name="assigned.last_name" :avatar="assigned.avatar" :subtitle="assigned.position?.name" exchange />
            </div>
            <div v-else class="ds-exchange-card-text">Нет откликов</div>
        </div>
    </div> 
</template>

<script setup lang="ts">
interface Props {
    vacancy: any
}
import { computed } from 'vue'
import dayjs from 'dayjs'
import User from '../User.vue';
import VacancyStatus from './VacancyStatus.vue';;
import Skills from './Skills.vue';
import { useScheduleStore } from '@/stores/scheduleStore';

const { vacancy } = defineProps<Props>()
const emit = defineEmits(['user', 'view'])
const store = useScheduleStore()

const date = computed(() => dayjs(vacancy.dttm_work_start_at).format('DD.MM.YYYY'))
const startTime = computed(() => dayjs(vacancy.dttm_work_start_at).format('HH:mm'))
const endTime = computed(() => dayjs(vacancy.dttm_work_end_at).format('HH:mm'))
const position = computed(() => vacancy.position.name)
const department = computed(() => vacancy.department.name)
const assigned = computed(() => vacancy.assigned_user)
const comment = computed(() => vacancy.comment)
const status = computed(() => vacancy.status)
const skills = computed(() => store.positions.find(item => item.name === position.value)?.skills || [])
const salary = computed(() => vacancy.salary_hour)

</script>
